// Get CIP user
// ========================================

import { useCancellableQuery } from "@/hooks/use-cancellable-query.hook";
import { CancellableQuery, CancellableQueryResponse, centralServerAxiosClient, defaultStaleTime, QueryError } from "@/services/config/api";
import { convertCentralServerErrorToCPException, extractDataFromResponse } from "@/services/helpers/axios.helpers";
import { CipUser } from "@EspaceParkQC/sdk-services-legacy";

export const GET_CIP_USER = "get-cip-user";

type GetCipUser = CancellableQuery<{}, CipUser, QueryError>;

export const getCipUser = async ({ signal }: GetCipUser): Promise<CipUser> => {
  try {
    const response = await centralServerAxiosClient.get<CipUser>("/v2/users/me", { signal });
    return extractDataFromResponse<CipUser>(response);
  } catch (error) {
    throw convertCentralServerErrorToCPException(error);
  }
};

export const useGetCipUserQuery = (query: GetCipUser): CancellableQueryResponse<CipUser> => {
  const { queryOptions } = query;
  return useCancellableQuery<CipUser, QueryError>([GET_CIP_USER], ({ signal }) => getCipUser({ signal }), {
    staleTime: defaultStaleTime,
    ...(queryOptions || {}),
  });
};

// Get clicknpark services auth token
// ========================================

export const GET_CLICKNPARK_SERVICES_AUTH_TOKEN = "get-clicknpark-services-auth-token";

export type ClicknparkServicesToken = {
  token: string;
  expiry: Date;
};

export const getClicknparkServicesToken = async (): Promise<ClicknparkServicesToken> => {
  try {
    const response = await centralServerAxiosClient.post<ClicknparkServicesToken>("/v2/users/me/auth/clicknpark/token");
    return extractDataFromResponse<ClicknparkServicesToken>(response);
  } catch (error) {
    throw convertCentralServerErrorToCPException(error);
  }
};
